<auto-main-navigation [accountId]="accountId?.toString()"></auto-main-navigation>

<div class="offer-set-list-page">
  <p-toast></p-toast>

  <div class="page-header">
    <div class="title-wrap">
      <h1>Offer Set List</h1>
    </div>
    <div class="header-actions">
      @if (enableNewOfferSetCreationModal) {
        <button pButton type="button" class="p-button-secondary" label="View Inventory"
                (click)="viewInventory()"></button>
        <button pButton type="button" class="p-button-warning build-new-offer-btn" label="+ Build New Offer Set"
                (click)="buildNewOfferSet()"></button>
      }
    </div>
  </div>

  <div class="toolbar">
    <div class="toolbar-section">
      <div class="toolbar-row">
        <div class="view-tabs">
          @for (tab of presetTabs; track tab.preset) {
            <button pButton type="button"
                    [class]="activePreset === tab.preset ? 'tab active' : 'tab'"
                    [label]="tab.label"
                    (click)="selectPreset(tab)">
            </button>
          }
        </div>
        <div class="search-wrap">
          <span class="p-input-icon-left search-input-wrap">
            <i class="pi pi-search"></i>
            <input pInputText
                   type="text"
                   placeholder="Search by title, stock #, VIN, year / make / model"
                   [value]="searchTerm"
                   (input)="onSearchChange($any($event.target).value)" />
          </span>
        </div>
      </div>
    </div>

    <div class="toolbar-section">
      <div class="toolbar-row">
        <div class="filters">
          <p-select [options]="statusOptions"
                    [(ngModel)]="selectedStatus"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Status"
                    [appendTo]="'body'"
                    (onChange)="onFilterChange()">
            <ng-template pTemplate="selectedItem" let-value>
              <span class="filter-prefix">Status:</span>
              <span class="filter-value">{{ value?.label }}</span>
            </ng-template>
          </p-select>
          <p-select [options]="conditionOptions"
                    [(ngModel)]="selectedCondition"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Condition"
                    [appendTo]="'body'"
                    (onChange)="onFilterChange()">
            <ng-template pTemplate="selectedItem" let-value>
              <span class="filter-prefix">Condition:</span>
              <span class="filter-value">{{ value?.label }}</span>
            </ng-template>
          </p-select>
          <p-select [options]="visibilityOptions"
                    [(ngModel)]="selectedVisibility"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Visibility"
                    [appendTo]="'body'"
                    (onChange)="onFilterChange()">
            <ng-template pTemplate="selectedItem" let-value>
              <span class="filter-prefix">Visibility:</span>
              <span class="filter-value">{{ value?.label }}</span>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
  </div>
  <div class="select-all-across" *ngIf="items.length > 0">
    <ng-container *ngIf="!selectAllAcrossPages; else allAcrossActiveTop">
      <div class="hint" *ngIf="areAllSelectableItemsSelected() && pagination.totalItems > getSelectableItemCount()">
        All {{ items.length }} items on this page are selected.
        <a href="#" (click)="$event.preventDefault(); selectAllAcross()">Select all {{ pagination.totalItems }} results</a>
      </div>
    </ng-container>
    <ng-template #allAcrossActiveTop>
      <div class="hint">
        All {{ pagination.totalItems }} results are selected across all pages.
        <a href="#" (click)="$event.preventDefault(); clearSelection()">Clear selection</a>
      </div>
    </ng-template>
  </div>

  <div class="table-card">
    <div class="table-header">
      <div class="table-title">Offer Sets</div>
      <div class="table-header-right">
      <span class="summary-text">
        Showing
        {{ pagination.totalItems === 0 ? 0 : ((pagination.page - 1) * pagination.pageSize) + 1 }}
        –
        {{ pagination.totalItems === 0 ? 0 : (((pagination.page * pagination.pageSize) > pagination.totalItems) ? pagination.totalItems : (pagination.page * pagination.pageSize)) }}
        of {{ pagination.totalItems }} results.
      </span>
        <div class="bulk-actions">
          <p-select [options]="bulkActionOptions"
                    [(ngModel)]="selectedBulkAction"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Bulk Action: Select"
                    [appendTo]="'body'">
          </p-select>
          <button pButton type="button"
                  class="p-button-secondary bulk-apply-btn"
                  label="Apply"
                  [disabled]="!selectedBulkAction || (!selectAllAcrossPages && selectedItems.length === 0)"
                  (click)="applyBulkAction()">
          </button>
        </div>
      </div>
    </div>


      @if (isLoading) {
        <div class="loading-container">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }

    @if (!isLoading && items.length === 0) {
      <div class="empty-state">
        <p>No Offer Sets found matching the current filters.</p>
      </div>
    }

    @if (!isLoading && items.length > 0) {
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th class="checkbox-col">
                <p-checkbox binary="true" [ngModel]="allSelected" [disabled]="getSelectableItemCount() === 0" (onChange)="toggleSelectAll($event)"></p-checkbox>
              </th>
              <th class="status-col">Status</th>
              <th class="vehicle-col">Vehicle</th>
              <th class="condition-col">Condition</th>
              <th class="visibility-col">Visibility</th>
              <th class="pricing-col">Pricing</th>
              <th class="offers-col">Offers</th>
              <th class="tags-col">Tags</th>
              <th class="dates-col">Dates</th>
              <th class="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td class="checkbox-col">
                  @if (!item.isShared) {
                    <p-checkbox binary="true" [ngModel]="isItemSelected(item)" (onChange)="toggleItemSelection(item)"></p-checkbox>
                  }
                </td>
                <td class="status-col">
                  <div class="status-toggle">
                    @if (!item.isShared) {
                      <p-toggleSwitch [ngModel]="item.data.active" [disabled]="item.isMissingMakeOrModel" (onChange)="toggleStatus(item)"></p-toggleSwitch>
                    }
                    <span>{{ item.data.active ? 'Active' : 'Inactive' }}</span>
                    @if (item.isMissingMakeOrModel) {
                      <span class="missing-make-model-note">*Missing Make/Model</span>
                    }
                  </div>
                </td>
                <td class="vehicle-col">
                  <div class="vehicle-cell">
                    <div class="vehicle-image">
                      @if (item.data.vehicleImage) {
                        <img [src]="item.data.vehicleImage" [alt]="item.data.displayTitle" />
                      }
                    </div>
                    <div class="vehicle-info">
                      <div class="vehicle-title">{{ item.data.displayTitle }}</div>
                      <div class="meta-line">Stock #: {{ item.data.stockNumber || 'N/A' }}</div>
                      <div class="meta-line">VIN: {{ item.data.vinNumber || 'N/A' }}</div>
                      @if (item.data.fullDisclosure) {
                        <a href="#" class="meta-line disclosure-link" (click)="openDisclosure(item); $event.preventDefault()">View Disclosure</a>
                      }
                      <div class="meta-line">Sale Ends: {{ item.data.saleEndDate ? (item.data.saleEndDate | date:'MM/dd/yy') : 'N/A' }}</div>
                    </div>
                  </div>
                </td>
                <td class="condition-col">
                  <span class="pill">{{ item.data.newUsed }}</span>
                </td>
                <td class="visibility-col">
                  <span class="pill">{{ item.data.visibilityScope }}</span>
                </td>
                <td class="pricing-col">
                  <div class="data-block">
                    <div class="data-label">MSRP</div>
                  <div class="data-value">{{ item.data.msrp ? ('$' + (item.data.msrp | number:'1.0-0')) : '—' }}</div>
                    <div class="data-label">Buy Price</div>
                  <div class="data-value">{{ item.data.buyPrice ? ('$' + (item.data.buyPrice | number:'1.0-0')) : '—' }}</div>
                </div>
              </td>
              <td class="offers-col">
                <div class="data-block">
                  <div class="data-label offer-label">
                    Lease
                    @if (publicOffersByOfferSetId[item.id]?.leaseOfferIsPublic) {
                      <a
                        class="tag public"
                        (click)="$event.preventDefault(); $event.stopPropagation(); openMatchedOfferSetEditor(publicOffersByOfferSetId[item.id]?.matchedOfferSetId)"
                        pTooltip="Lease Offer Source: {{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetTitle || 'Unknown') }} ({{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetId || 'Unknown') }})"
                        tooltipPosition="top">
                        Public
                      </a>
                    }
                  </div>
                  <div class="data-value">{{ (item.data.leasePrice > 0) ? ('$' + (item.data.leasePrice | number:'1.0-0') + '/mo for ' + item.data.leaseTerm + ' mos.'  ) : '—' }}</div>
                  <div class="data-label offer-label">
                    APR
                    @if (publicOffersByOfferSetId[item.id]?.aprOfferIsPublic) {
                      <a
                        class="tag public"
                        (click)="$event.preventDefault(); $event.stopPropagation(); openMatchedOfferSetEditor(publicOffersByOfferSetId[item.id]?.matchedOfferSetId)"
                        pTooltip="APR Offer Source: {{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetTitle || 'Unknown') }} ({{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetId || 'Unknown') }})"
                        tooltipPosition="top">
                        Public
                      </a>
                    }
                  </div>
                  <div class="data-value">{{ (item.data.availableApr && item.data.availableAprText) ? (item.data.availableApr + '% for ' + item.data.availableAprText + ' mos.') : '—' }}
                  </div>
                  <div class="data-label offer-label">
                    Finance
                    @if (publicOffersByOfferSetId[item.id]?.financeOfferIsPublic) {
                      <a
                        class="tag public"
                        (click)="$event.preventDefault(); $event.stopPropagation(); openMatchedOfferSetEditor(publicOffersByOfferSetId[item.id]?.matchedOfferSetId)"
                        pTooltip="Finance Offer Source: {{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetTitle || 'Unknown') }} ({{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetId || 'Unknown') }})"
                        tooltipPosition="top">
                        Public
                      </a>
                    }
                  </div>
                  <div class="data-value">{{ (item.data.financePayment > 0 && item.data.financeTerm > 0) ? (item.data.financeTerm ? ('$' + (item.data.financePayment | number:'1.0-0') + '/mo for ' + item.data.financeTerm + ' mos.') : ('$' + (item.data.financePayment | number:'1.0-0'))) : '—' }}</div>
                  <div class="data-label offer-label">
                    Alternate Lease
                    @if (publicOffersByOfferSetId[item.id]?.alternateLeaseIsPublic) {
                      <a
                        class="tag public"
                        (click)="$event.preventDefault(); $event.stopPropagation(); openMatchedOfferSetEditor(publicOffersByOfferSetId[item.id]?.matchedOfferSetId)"
                        pTooltip="Alternate Lease Offer Source: {{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetTitle || 'Unknown') }} ({{ (publicOffersByOfferSetId[item.id]?.matchedOfferSetId || 'Unknown') }})"
                        tooltipPosition="top">
                        Public
                      </a>
                    }
                  </div>
                  <div class="data-value">{{ (item.data.zeroDownLeasePrice > 0) ? ('$' + (item.data.zeroDownLeasePrice | number:'1.0-0') + '/mo for ' + item.data.zeroDownLeaseTerm + ' mos.'  ) : '—' }}</div>
                </div>
              </td>
                <td class="tags-col">
                  <div class="tag-group">
                    @if (item.data.featuredSpecial) { <span class="tag featured">Featured</span> }
                    @if (item.data.isPrivate) { <span class="tag private">Private</span> }
                    @if (item.data.isCreativeOffer) { <span class="tag creative">Creative</span> }
                    @if (item.data.isCustomizedOfferSet) { <span class="tag custom">Customized</span> }
                    @if (item.isShared) { <span class="tag shared">Shared</span> }
                    @if (hasActivePublicOffer(item.id)) { <span class="tag public-offer-set">Public</span> }
                  </div>
                </td>
                <td class="dates-col">
                  <div class="meta-line"><strong>Created:</strong> {{ item.data.created ? (item.data.created | date:'MM/dd/yyyy') : '—' }}</div>
                  <div class="meta-line"><strong>Updated:</strong> {{ item.data.modified ? (item.data.modified | date:'MM/dd/yyyy') : '—' }}</div>
                </td>
                <td class="actions-col">
                  <div class="row-actions">
                    @if (!item.isShared) {
                      <button pButton type="button" class="p-button-text p-button-info action-btn" icon="pi pi-pencil" (click)="editOfferSet(item)"></button>
                      <button pButton type="button" class="p-button-text p-button-danger action-btn" icon="pi pi-trash" (click)="openDeleteConfirmation(item)"></button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="select-all-across" *ngIf="items.length > 0">
        <ng-container *ngIf="!selectAllAcrossPages; else allAcrossActive">
          <div class="hint" *ngIf="areAllSelectableItemsSelected() && pagination.totalItems > getSelectableItemCount()">
            All {{ items.length }} items on this page are selected.
            <a href="#" (click)="$event.preventDefault(); selectAllAcross()">Select all {{ pagination.totalItems }} results</a>
          </div>
        </ng-container>
        <ng-template #allAcrossActive>
          <div class="hint">
            All {{ pagination.totalItems }} results are selected across all pages.
            <a href="#" (click)="$event.preventDefault(); clearSelection()">Clear selection</a>
          </div>
        </ng-template>
      </div>

      <div class="pagination-bar">
        <p-paginator [rows]="pagination.pageSize"
                     [totalRecords]="pagination.totalItems"
                     [first]="(pagination.page - 1) * pagination.pageSize"
                     [rowsPerPageOptions]="[25, 50, 100]"
                     (onPageChange)="onPageChange($event)">
        </p-paginator>
      </div>
    }
  </div>

  <p-confirmDialog key="deleteOfferSet"></p-confirmDialog>
  <p-confirmDialog key="bulkDeleteOfferSets"></p-confirmDialog>

  <p-dialog [(visible)]="disclosureDialogVisible"
            [modal]="true"
            [style]="{width: '600px', maxWidth: '95vw'}"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            (onHide)="closeDisclosure()"
            [header]="disclosureTitle || 'Disclosure'">
    <div class="disclosure-content" [innerHTML]="disclosureHtml"></div>
    <ng-template pTemplate="footer">
      <button pButton type="button" label="Close" (click)="closeDisclosure()"></button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="buildDialogVisible"
            [modal]="true"
            [style]="{width: '600px', maxWidth: '95vw'}"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            [focusOnShow]="false"
            (onHide)="closeBuildDialog()"
            header="Build New Offer Set">
    <div class="build-offer-set-options">
      <button pButton type="button" class="build-option-tile p-button-warning"
              label="Enter from Stock" (click)="selectEnterFromStock()"></button>
      <button pButton type="button" class="build-option-tile p-button-warning"
              label="Manually Create Offer Set" (click)="selectManualCreate()"></button>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="manualDialogVisible"
            [modal]="true"
            [style]="{width: '600px', maxWidth: '95vw'}"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            (onHide)="closeManualDialog()"
            header="Manually Create Offer Set">
    <div class="build-offer-set-form">
      <div class="build-form-field">
        <label>Condition</label>
        <p-select [options]="buildConditionOptions"
                  [(ngModel)]="newOfferSetCondition"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Condition"
                  [appendTo]="'body'">
        </p-select>
      </div>
      <div class="build-form-field">
        <label>Year</label>
        <p-select
          [options]="yearOptions"
          [(ngModel)]="newOfferSetYear"
          placeholder="Year"
          [appendTo]="'body'">
        </p-select>
      </div>
      <div class="build-form-field">
        <label>Make</label>
        <p-select [options]="makes"
                  [(ngModel)]="newOfferSetMakeId"
                  optionLabel="displayName"
                  optionValue="id"
                  placeholder="Make"
                  [appendTo]="'body'"
                  (onChange)="onBuildMakeChange()">
        </p-select>
      </div>
      <div class="build-form-field">
        <label>Model</label>
        <p-select [options]="filteredModels"
                  [(ngModel)]="newOfferSetModelId"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Model"
                  [appendTo]="'body'">
        </p-select>
      </div>
      <div class="build-form-field">
        <label>Trim</label>
        <input pInputText type="text" [(ngModel)]="newOfferSetTrim" placeholder="Trim (optional)"/>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-secondary" label="Back" (click)="backToBuildDialog()"></button>
      <button pButton type="button" label="Create"
              [disabled]="!newOfferSetCondition || !newOfferSetYear || !newOfferSetMakeId || !newOfferSetModelId"
              (click)="manuallyCreateOfferSet()"></button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="stockDialogVisible"
            [modal]="true"
            [style]="{width: '600px', maxWidth: '95vw'}"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            (onHide)="closeStockDialog()"
            header="Enter from Stock">
    <div class="build-offer-set-form">
      <div class="build-form-field">
        <label>Stock Number</label>
        <input pInputText type="text" [(ngModel)]="newOfferSetStockNumber" placeholder="Stock Number"/>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-secondary" label="Back"
              (click)="backToBuildDialogFromStock()"></button>
      <button pButton type="button" label="Create"
              [disabled]="!newOfferSetStockNumber || isCreatingFromStock"
              [loading]="isCreatingFromStock"
              (click)="enterFromStock()"></button>
    </ng-template>
  </p-dialog>
</div>
